import { BaseDto } from './base.dto';
import { IsDefined, IsInt, IsNumber, IsOptional } from 'class-validator';

export class RecipeVariancesDetailDto extends BaseDto {
  @IsDefined()
  @IsInt()
  stockVariancesId: number;

  @IsDefined()
  @IsInt()
  recipeId: number;

  @IsDefined()
  @IsInt()
  recipeLocationId: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  quantity: number;

  @IsOptional()
  outOfStock: boolean;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  batchQty: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  portionQty: number;

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  splitQty: number

  @IsOptional()
  @IsNumber({maxDecimalPlaces: 2})
  totalAMT: number;

}
